import { JSX, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import { useGetList } from 'react-admin';
import { Operator } from "../../../../../types/entities";
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import { OperatorTile } from "./components/OperatorTile";

export const DialOperator: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const [connectingToOperator, setConnectingToOperator] = useState<boolean>(false);

    const { data, isPending, error } = useGetList(
        'operators',
        {
            pagination: { page: 1, perPage: 10 },
            sort: { field: 'available', order: 'DESC' }
        }
    );

    return (
        <div className="testing__operator">
            { (isPending) &&
                <div className="operator__loading">
                    <div className="loading">
                        <HeadsetMicIcon />
                        <span className="loading-span">{ "Loading..." }</span>
                    </div>
                </div>
            }

            { (!isPending) &&
                <div className="operator__list">
                    { data.map( (operator: Operator, index: number): JSX.Element => {
                        return (
                            <OperatorTile
                                key={ "operator_item_" + index }
                                operator={ operator }
                                setConnectingToOperator={ setConnectingToOperator }
                            />
                        );
                    }) }
                </div>
            }

            { (error) &&
                <div className="operator__list-error">
                    <span>{ "Something has gone wrong loading operators." }</span>
                </div>
            }

            { (connectingToOperator) &&
                <div className="operator__connecting">
                    <div className="connecting">
                        <HeadsetMicIcon />
                        <span className="loading-span">{ "Loading" }</span>
                    </div>
                </div>
            }
        </div>
    );
}